import { render } from "./gbzntjs.vue?vue&type=template&id=a84f803e&scoped=true"
import script from "./gbzntjs.vue?vue&type=script&lang=js"
export * from "./gbzntjs.vue?vue&type=script&lang=js"

import "./gbzntjs.vue?vue&type=style&index=0&id=a84f803e&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84f803e"]])

export default __exports__